import { Component, OnInit, signal } from '@angular/core';
import { collection, getDocs, setDoc, doc, query, where, deleteDoc } from 'firebase/firestore';
import {
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { Setting } from 'src/app/interfaces';
import { MatCheckboxChange, MatCheckbox } from '@angular/material/checkbox';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
  UntypedFormControl,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { db } from 'src/app/app.component';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect, MatOption } from '@angular/material/select';
import { MatButton } from '@angular/material/button';
@Component({
  selector: 'app-add-user-to-orgs',
  templateUrl: './add-user-to-orgs.component.html',
  styleUrls: ['./add-user-to-orgs.component.scss'],
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatSelect,
    MatOption,
    MatCheckbox,
    MatDialogActions,
    MatButton,
    MatDialogClose,
  ],
})
export class AddUserToOrgsComponent implements OnInit {
  superUserForm: UntypedFormGroup;
  orgs = signal<any[]>([]);
  superUsers = signal<any[]>([]);

  constructor(
    private fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<AddUserToOrgsComponent>,
  ) {}

  async ngOnInit(): Promise<void> {
    this.superUserForm = this.fb.group({
      user: ['', Validators.required],
    });
    await this.getOrgs();
    await this.getSuperUsers();
    console.log('this.orgs', this.orgs());
    console.log('superUsers', this.superUsers());
    this.superUserForm.get('user').valueChanges.subscribe((value) => {
      this.resetCheckboxes();
      value.organisations.forEach((orgInUser) => {
        if (this.orgs().find((org) => org.id === orgInUser.id)) {
          const index = this.orgs().indexOf(this.orgs().find((org) => org.id === orgInUser.id));
          const updatedOrgs = [...this.orgs()];
          updatedOrgs[index]['checked'] = true;
          this.orgs.set(updatedOrgs);
        }
      });
    });
  }

  async getOrgs() {
    const orgDocs = await getDocs(collection(db, `organisations`));

    const orgsArray: any[] = [];
    orgDocs.forEach((doc) => {
      const docData = doc.data() as Setting;
      const orgData = { ...docData, id: doc.id, checked: false };
      orgsArray.push(orgData);
    });

    orgsArray.sort((a, b) => a.name.localeCompare(b.name));
    this.orgs.set(orgsArray);

    this.orgs().forEach((org) => {
      this.superUserForm.addControl(org.id, new UntypedFormControl(org.checked));
    });
  }

  async getSuperUsers() {
    const q = query(collection(db, `users`), where('rights', '==', 'admin'));
    const superUserDocs = await getDocs(q);
    const superUsersArray: any[] = [];
    superUserDocs.forEach((doc) => {
      const docData = doc.data();
      const superUserData = { ...docData, id: doc.id };
      superUsersArray.push(superUserData);
    });

    superUsersArray.sort((a, b) => a.name.localeCompare(b.name));
    this.superUsers.set(superUsersArray);
  }

  orgChecked(event: MatCheckboxChange, value: any) {
    const index = this.orgs().indexOf(value);
    const updatedOrgs = [...this.orgs()];
    updatedOrgs[index]['checked'] = event.checked;
    this.orgs.set(updatedOrgs);
    console.log(this.orgs());
  }

  resetCheckboxes() {
    const updatedOrgs = this.orgs().map((org) => ({
      ...org,
      checked: false,
    }));
    this.orgs.set(updatedOrgs);
  }

  getSelectedOrgs() {
    const selectedOrgs = [];
    this.orgs().forEach((org) => {
      if (org.checked) {
        selectedOrgs.push({ roles: ['administrator'], id: org.id, name: org.name });
      }
    });
    return selectedOrgs;
  }

  getNonSelectedORgs() {
    const nonSelectedOrgs = [];
    this.orgs().forEach((org) => {
      if (!org.checked) {
        nonSelectedOrgs.push({
          roles: ['administrator'],
          id: org.id,
          name: org.name,
        });
      }
    });
    return nonSelectedOrgs;
  }

  async save() {
    const selectedOrgs = this.getSelectedOrgs();
    const nonSelectedOrgs = this.getNonSelectedORgs();
    const userId = this.superUserForm.value.user.id;
    const promises: any[] = [];
    try {
      promises.push(
        await setDoc(
          doc(db, `users/${userId}`),
          {
            organisations: selectedOrgs,
          },
          { merge: true },
        ),
      );

      selectedOrgs.forEach(async (org) => {
        promises.push(
          await setDoc(
            doc(db, `/organisations/${org.id}/users/${userId}`),
            {
              roles: ['administrator'],
              email: this.superUserForm.value.user.email,
              name: this.superUserForm.value.user.name,
              superuser: true,
            },
            { merge: true },
          ),
        );
      });

      nonSelectedOrgs.forEach(async (org) => {
        promises.push(await deleteDoc(doc(db, `/organisations/${org.id}/users/${userId}`)));
      });
    } catch (error) {
      console.log(error);
    }
    await Promise.all(promises);
    this.dialogRef.close();
  }
}
